/**
 * Strips Bonusly tokens (+amount, @mention) from draft text and returns the
 * length of the remaining content. Used by the gratitude-gauge scoring /
 * draft-assist gates to decide whether a draft is long enough to act on.
 *
 * Trim after stripping so interstitial spaces left by recipient/amount pills
 * (e.g. "@alice +10 ") do not count as content. Strips every +amount, not only
 * the first, so an amounts-only draft ("+10 +5") is treated as empty.
 */
export function cleanedDraftLength(draftText: string): number {
	const trimmed = draftText.trim();
	return trimmed
		.replace(/\+\d+/g, '')
		.replaceAll(/@[^ ]+/g, '')
		.trim().length;
}
